export default __webpack_public_path__ + "static/hispanicmanwithglobe-477c30d4ad04c64429f75e61775c185f.jpg";